import * as React from 'react';
import { BaseRouteProps } from '../../../interfaces';
import { PVAPage } from '../../../components';
import { ScoreCardDataService } from '../../../services';
import { NavLink } from 'react-router-dom';
import { ScoreCardForm } from './ScoreCardForm';

export class ScoreCardCreate extends React.Component<BaseRouteProps<{}>> {
    private scoreCardDataService = new ScoreCardDataService(this.props.notificationService);

    constructor(props: BaseRouteProps<{}>) {
        super(props);

        this.state = {
            originalEntity: undefined
        };

        this.save = this.save.bind(this);
    }

    public render() {
        return (
            <PVAPage>
                <PVAPage.Header>
                    <PVAPage.Header.Title>
                        <NavLink to={`/scorecards`}>
                            <span className="glyphicon glyphicon-triangle-left" />
                        </NavLink>
                        &nbsp;
                        Create Score Card
                    </PVAPage.Header.Title>
                </PVAPage.Header>

                <PVAPage.Body>
                    <ScoreCardForm submit={(e: any) => this.save(e)} defaultValues={{}} />
                </PVAPage.Body>

                <PVAPage.Footer />
            </PVAPage>);
    }

    private save(values: any) {
        this.scoreCardDataService.create(values).then((success) => {
            this.props.history.push(`/scorecards/${success.id}`);
        });
    }
}


// WEBPACK FOOTER //
// ./src/components/scoreCard/scoreCard/ScoreCardCreate.tsx